/// <reference path="../../Common/Helpers/GridEditorBase.ts" />
/// <reference path="../../_ext/editors/grideditorbase.ts" />

namespace TabAurous.Inventory {

    import fld = BranchInItemsRow.Fields;

    @Serenity.Decorators.registerClass()
    export class BranchInItemsEditor extends _Ext.ItemGridEditor<BranchInItemsRow> {
        protected getColumnsKey() { return "Inventory.BranchInItems"; }
        protected getDialogType() { return BranchInItemsDialog; }
        protected getLocalTextPrefix() { return BranchInItemsRow.localTextPrefix; }

        protected form: BranchInItemsForm;

        constructor(container: JQuery) {
            super(container);
            this.slickGrid.setOptions({ forceFitColumns: true });
        }
    }
}